import React, { useState } from "react";
import Check from "../../../assets/question/check.png";
import X from "../../../assets/question/x.png";
import BasicLayout from "../../../layouts/BasicLayout";
import Modal from "../../Modal";
import Stars from "../../Stars";
import "./index.scss";
import Woman from "../../../assets/woman.png";
import Man from "../../../assets/man.png";
import Bird1 from "../../../assets/bird1.png";
import Bird2 from "../../../assets/bird2.png";
import Bird3 from "../../../assets/bird3.png";
import First from "../../../assets/splitimages/12.jpg";
import Second from "../../../assets/splitimages/11.jpg";
import Third from "../../../assets/splitimages/10.jpg";
import Fourth from "../../../assets/splitimages/9.jpg";
import Fifth from "../../../assets/splitimages/8.jpg";
import Sixth from "../../../assets/splitimages/7.jpg";
import Seventh from "../../../assets/splitimages/6.jpg";
import Eighth from "../../../assets/splitimages/5.jpg";
import Ninth from "../../../assets/splitimages/4.jpg";
import Tenth from "../../../assets/splitimages/3.jpg";

const Question = ({ index, submitAnswer, current, item, system }) => {
  const [myAnswer, updateMyAnswer] = useState("");
  const [points, setPoints] = useState(0);
  const [cluesUsed, setCluesUsed] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [modelClue, setModalClue] = useState("");
  const [correct, setCorrect] = useState("unsure");

  const focusHandler = event => {
    if (system === "Android") {
      document.getElementById(`questions-detect`).style.transitionProperty = `none`;
    }
    document.getElementsByClassName("next")[index].style.opacity = 0;
    document.getElementsByClassName("next")[index].style.pointerEvents = "none";
  };

  const blurHandler = event => {
    document.getElementsByClassName("next")[index].style.opacity = 1;
    document.getElementsByClassName("next")[index].style.pointerEvents = "auto";
  };

  document.getElementById(`input-${index}`) &&
    document.getElementById(`input-${index}`).addEventListener("focus", focusHandler);

  document.getElementById(`input-${index}`) &&
    document.getElementById(`input-${index}`).addEventListener("blur", blurHandler);

  const handleClueClick = clue => {
    setOpen(true);
    setModalClue(clue);
    if (!cluesUsed.includes(clue)) {
      setCluesUsed([...cluesUsed, clue]);
    }
  };

  const renderAnimation = () => {
    return (
      <div className="animation-container">
        {index === 6 && (
          <img className={`bg-element woman`} style={{ opacity: current === 4 ? 1 : 0 }} src={Woman} width="300px" />
        )}
        {index === 5 && (
          <img className={`bg-element man`} style={{ opacity: current === 5 ? 1 : 0 }} src={Man} width="300px" />
        )}
        {index === 7 && <img className={`bg-element bird2`} src={Bird2} width="120px" />}
        {index === 8 && <img className={`bg-element bird3`} src={Bird3} width="120px" />}
        {index === 9 && <img className={`bg-element bird1`} src={Bird1} width="120px" />}
        {index === 9 && (
          <img
            className={`bg-element woman`}
            style={{ opacity: current === 1 ? 1 : 0, transform: `translateX(-${current === 1 ? 40 : 0}px)` }}
            src={Woman}
            width="300px"
          />
        )}
        {index === 9 && (
          <img
            className={`bg-element man`}
            style={{ opacity: current === 1 ? 1 : 0, transform: `translateX(${current === 1 ? 40 : 0}px)` }}
            src={Man}
            width="300px"
          />
        )}
      </div>
    );
  };

  const renderURL = () => {
    switch (index) {
      case 0:
        return First;
      case 1:
        return Second;
      case 2:
        return Third;
      case 3:
        return Fourth;
      case 4:
        return Fifth;
      case 5:
        return Sixth;
      case 6:
        return Seventh;
      case 7:
        return Eighth;
      case 8:
        return Ninth;
      case 9:
        return Tenth;
      default:
        return;
    }
  };

  return (
    <BasicLayout>
      <div className="current-question">{index + 1}/10</div>
      <div className="particles">
        <Stars />
      </div>
      {isOpen && <Modal closeModal={() => setOpen(false)} clue={modelClue} />}
      <div className="clues">
        {item.clues.map((clue, index) => (
          <div key={index} className="clue" onClick={() => handleClueClick(clue)} />
        ))}
      </div>
      <div
        id={index + 1}
        className="question-container"
        style={{ background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${renderURL()})` }}
      >
        {renderAnimation()}
        <div className="question" style={{ fontSize: item.question.length > 56 && "0.9rem" }}>
          <div className="question-content" style={{ width: item.id === "28" && "300px" }}>
            {item.question.split(";").map((item, key) => (
              <div key={key}>
                {item.split(",").map((item, key) => {
                  return <div key={key}>{item}</div>;
                })}
              </div>
            ))}
          </div>
          <div className="hint">{item.hint}</div>
        </div>
        <div className="my-answer">
          <form
            onSubmit={e => {
              e.preventDefault();
              document.getElementById(`${index + 1}`).scrollIntoView({ behavior: "smooth" });
              if (myAnswer) {
                setSubmit(true);
                if (item.answers.includes(myAnswer)) {
                  setPoints(10 - cluesUsed.length * 2);
                  setCorrect("correct");
                } else {
                  setPoints(0);
                  setCorrect("incorrect");
                }
              }
            }}
          >
            <div className="input-feedback">
              <input
                id={`input-${index}`}
                value={myAnswer}
                onChange={e => updateMyAnswer(e.target.value)}
                style={{ pointerEvents: submit && "none", opacity: submit && 0.8 }}
              />
              {correct === "correct" && <img width="24px" src={Check} />}
              {correct === "incorrect" && <img width="24px" src={X} />}
            </div>
            <div className="submission">
              {submit ? (
                <div className="answer">
                  <span>迷底：{item.answers[0]}</span>
                  <p className="explanation">{item.explanation}</p>
                </div>
              ) : (
                <input type="submit" value="提交答案" />
              )}
            </div>
          </form>
        </div>
        <div className="next">
          <button onClick={() => submitAnswer(points)}>下一题</button>
        </div>
      </div>
    </BasicLayout>
  );
};

export default Question;
